import { useMutation } from '@tanstack/react-query';

import { Slide } from '../components/SlideComponents/slide.types';
import BackendService from '../services/backendService';
import { LessonAttachment } from '../services/backendService/backendService';
import useRouterMatch from './useRouterMatch';

const useCreateLessonFromSample = (tenantId: string) => {
  const { router } = useRouterMatch();
  const { mutate: createLesson, isLoading: isCreatingLesson } = useMutation(
    ({
      presentationId,
      slides,
      tenantId,
      lessonAttachments,
      onSuccess,
    }: {
      presentationId: string;
      slides: Slide[];
      lessonAttachments?: LessonAttachment[];
      tenantId: string;
      onSuccess?: () => void;
    }) => {
      return BackendService.instance.presentations.createLessonFromSample({
        presentationId,
        slides,
        tenantId,
        isPresented: true,
        lessonAttachments,
      });
    },
    {
      onSuccess: (response, { onSuccess }) => {
        if (onSuccess) {
          onSuccess();
        }
        router.push(`/${tenantId}/games/${response.livePresentationId}/live`);
      },
    },
  );

  return {
    createLesson,
    isCreatingLesson,
  };
};

export default useCreateLessonFromSample;
